export default "__VITE_ASSET__DHjzPSvq__"